import React, { useEffect, useState } from "react";
import { format, isValid, parseISO } from "date-fns";
import GlobalDataTable from "../../../global/GlobalDataTable";
import GlobalFeedback from "../../../global/GlobalFeedback";
import { GlobalButton } from "../../../global/forms/GlobalFormFields";
import { getDonor80GCertificates } from "../api/donorPanelApi";

function formatDateCell(value) {
  if (!value) return "-";
  const d = parseISO(String(value));
  return isValid(d) ? format(d, "PP") : String(value);
}

function downloadCertificateText(certificateNo, dateText) {
  const blob = new Blob(
    [`80G Certificate No: ${certificateNo}\nIssue Date: ${dateText}`],
    { type: "text/plain;charset=utf-8" },
  );
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `80g-certificate-${certificateNo}.txt`;
  a.click();
  URL.revokeObjectURL(url);
}

export default function Donor80GCertificates() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await getDonor80GCertificates();
        if (!alive) return;
        setRows(Array.isArray(res?.data) ? res.data : []);
      } catch (err) {
        if (!alive) return;
        setError(err?.message || "Failed to load 80G certificates");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="user-builder-panel">
      <h3 className="user-builder-panel__title">80G Certificates</h3>
      <GlobalFeedback type="error" text={error} />
      {loading ? (
        <p>Loading 80G certificates...</p>
      ) : (
        <GlobalDataTable
          tableAriaLabel="80G certificates table"
          headers={[
            { key: "certificate_number", label: "Certificate No" },
            { key: "certificate_issue_date", label: "Date" },
            { key: "download", label: "Download PDF" },
          ]}
        >
          {rows.length === 0 ? (
            <tr>
              <td colSpan={3} style={{ textAlign: "center", padding: "1rem" }}>
                No 80G certificates available.
              </td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr key={row.id}>
                <td>{row.certificate_number || "-"}</td>
                <td>{formatDateCell(row.certificate_issue_date)}</td>
                <td>
                  <GlobalButton
                    type="button"
                    size="sm"
                    variant="ghost"
                    onClick={() =>
                      downloadCertificateText(
                        row.certificate_number || "unknown",
                        formatDateCell(row.certificate_issue_date),
                      )
                    }
                  >
                    Download PDF
                  </GlobalButton>
                </td>
              </tr>
            ))
          )}
        </GlobalDataTable>
      )}
    </div>
  );
}
